const message = {
  menu: {
    "user-menu": "User Menu",
    "my-meeting": "My Meeting",
    "my-calendar": "My Calendar",
    "open-meeting": "Open Meeting",
    "daily-meeting": "Daily Meeting",
    "weekly-meeting": "Weekly Meeting",
    "monthly-meeting": "Monthly Meeting",
    "my-record-file": "My Record File",
    "meeting-reserve": "Meeting Reserve",
    profile: "Profile",
    "admin-menu": "Administrator Menu",
    dashboard: "Dashboard",
    statistics: "Statistics",
    "meetingroom-mgr": "Meeting Room Manager",
    "device-mgr": "Video Room Manager", // 'Device Manager',
    "user-mgr": "User Manager",
    "record-mgr": "Recording File Manager",
    "webex-license": "WebEx License",
    "system-mgr": "System Manager",
    "help-desk": "Help Desk : {helpDeskNumber}",
    logs: "Log",
    "cisco-webex-hub": "Cisco Webex Hub",
    license: "License",
    history: "Webex History",
    home: "Home",
    "my-reserve": "MyReserve",
    "join-meeting": "JoinMeeting",
  },
  dialog: {
    warning: {
      delete: "Delete",
      cancel: "Cancel",
    },
    info: {
      confirm: "Confirm",
      close: "Close",
    },
    add: {
      add: "Add",
      cancel: "Cancel",
    },
    update: {
      update: "Update",
      cancel: "Cancel",
    },
    license: {
      title: "license Term",
      content: "Please check the license expiration date.",
      "expire-date": "expire date",
      confirm: "Confirm",
    },
  },
  util: {
    floor: "Floor",
  },
  "page-header": {
    "notice-message": "{name},  Welcome to the video conference system.",
    profile: "Profile",
    "personal-address": "Address Book",
    logout: "Logout",
    manual: "Manual",
  },
  page: {
    home: {
      description:
        "Smart video conferencing system that can be used anywhere with place restrictions",
      "ecs-cloud-meeting-system": "ECS CONFERENCEING SYSTEM",
      "today-meeting": "Today Meeting",
      list: "List",
      "create-meeting": "Reserve & Create",
      reserve: "Reserve",
      "create-meeting-info":
        "You can check and make reservations for video conferences.",
      "open-conference": "Open Conference",
      waiting: "Waiting",
      available: "Available",
      "reserve-time-info": "Reserve until ~{time}",
    },
    "today-meeting": {
      "header-title": "Today Meetiong",
      "user-meeting-msg": "오늘 {name}님이 참여하실 회의 일정입니다.",
      title: "Meeting Title",
      creator: "Creator",
      "meeting-time": "Meeting Time",
      status: "Status",
      "meeting-info": "Meeting Info",
      edit: "Edit",
      "attendee-list-string": "{name} 외 {count} 명",
      "attendee-list-string0": "{name}",
      join: "Join",
      start: "Start",
      waiting: "Waiting",
      reservation: "Reservation",
      end: "End",
      info: "Info",
    },
    "meeting-info": {
      title: "Meeting Info",
      "conference-room": "Room",
      "meeting-title": "Meeting Title",
      creator: "Creator",
      "meeting-key": "Meeting Key",
      "host-key": "Host Key",
      password: "Password",
      "end-time": "End Time",
      reserve: "Reserved",
      "meeting-day-time": "Meeting Date/Time",
      attendee: "Attendees",
      "show-all": "Show All",
      "meeting-room": "Meeting Room",
    },
    "meeting-reserve": {
      bookmark: {
        "add-bookmark-msg": "주소록이 추가되었습니다.",
        "delete-bookmark-msg": "선택된 주소록이 삭제되었습니다.",
        "delete-bookmark-fail-msg": "주소록 삭제 실패하였습니다",
      },
      "create-meeting": "Create Meeting",
      "edit-meeting": "Edit Meeting",
      "meeting-room": "Meeting Room",
      "meeting-name": "Meeting Name",
      "meeting-time": "Meeting Time",
      "start-now": "Now ~",
      attendee: "Attendee",
      password: "Password",
      "submit-reserve": "Reserve",
      save: "Save",
      "delete-reserve": "Delete",
      "attendee-list": "Attendee List",
      "attendee-list-string": "{name} 외 {count} 명",
      until: "Until",
      "select-option": "Selection Option",
      "repeat-setting": "Repeat Setting",
      setting: "설정",
      weekly: "Weekly",
      daily: "Daily",
      "search-msg": "Add by entering employee search or E-mail",
      immediate: "Immediate",
      "time-error": "The start time and end time are incorrect.",
      "end-time-error": "The end time are incorrect.",
    },
    "my-meeting": {
      "header-title": "My Meetings",
      "user-meeting-msg": "오늘 {name}님이 참여하실 회의 일정입니다.",
      "all-select": "All Select",
      delete: "Delete",
      "meeting-info": "Meeting Info",
      attendee: "Attendee",
      "meeting-room": "Meeting Room",
      status: "Status",
      info: "Info",
      edit: "Edit",
      select: "Select",
      creator: "Creator",

      "meeting-time-line": "Meeting Timeline Today",
      "meeting-time-line-no-result": "There is no meeting today.",
      "meeting-time-line-no-meeting-room": "No meeting rooms selected.",
      "meeting-join": "Join",
      "all-my-meeting": "All My Meetings",
      "meeting-reserve": "Reserve Meeting",
      "immediate-reserve": "Immediate Meeting",
      "all-meeting-gird": {
        "meeting-date": "Date",
        "meeting-time": "Time",
        type: "Type",
        "meeting-type": "Meeting Type",
        "meeting-name": "Meeting Name",
        "meeting-sta-time": "Start Time",
        "meeting-end-time": "End Time",
        creator: "Creator",
        attendee: "Attendee",
        building: "Building",
        "meeting-key": "Meeting Number",
        "meeting-pw": "Meeting PW",
        "meeting-host-key": "Host Key",
        "meeting-url": "Join Url",
        "meeting-room": "Meeting Room",
        repeat: "Repeat",
        status: "Status",
        control: "Control",
        detail: "Detail",
        delete: "Edit/Delete",
      },
      video: "video",
      room: "room",
      lecture: "Lecture",
      "immediate-short": "Immediatly",
      proceeding: "Proceeding",
      finish: "Finish",
      reserve: "reserved",
      "canceled-meeting": "The meeting has been canceled.",
      "delete-meeting": "Delete Meeting",
      "delete-meeting-content":
        "Are you sure you want to cancel the selected meeting?",
    },
    "join-meeting": {
      "header-title": "Joined Meeting",
      "meeting-date": "Meeting Date",
      "meeting-time": "Meeting Time",
      "meeting-title": "Meeting Title",
      creator: "Creator",
      "meeting-info": "Meeting Info",
      "join-info": "Join Info",
      "record-file": "Record File",
      "meeting-day-time": "Meeting Date/Time",
      "join-per": "Attendance Rate",
      "join-count": "Participants N.",
      "attendee-count": "Invited N",
      attnedee: "Attnedee",
      "join-not-join": "Participated/Not Participated",
      participated: "Participated",
      "not-participated": "Not Participated",
      "join-time": "Join Time",
      "leave-time": " Leave Time",
      "join-duration": "Duration(M)",
      minute: "M",
      "video-device": "Codec",
      "no-join-people-msg": "There are no participants.",
      "join-people-processing-msg":
        "Participant information is being calculated. (It takes 1-2 days.)",
      "no-join-codec-msg": "There are no joined codecs.",
      "join-codec-processing-msg":
        "Joined codecs information is being calculated. (It takes 1-2 days.)",
      "rec-file-select": "Select Record File",
      streaming: "Streaming",
      download: "Download",
    },
    profile: {
      "header-title": "Profile",
      id: "ID",
      name: "Name",
      grade: "Grade",
      company: "Company",
      edit: "Edit",
      "edit-pop-title": "Profile Info Edit",
      password: "Password",
      "password-mod": "Password Modify",
      "company-select": "Select Company",
      building: "Building",
      "building-select": "Select Building",
      floor: "Floor",
      "floor-select": "Select Floor",
      save: "Save",
      "edit-profile-complete": "Your profile has been modified.",
      "edit-profile-fail": "Profile modification failed.",
      "pw-mod": "Modify Password",

      "profile-info": "Profile Information",
      "put-position-msg": "Please enter your position.",
      "empty-about-me-msg": "What you type in About Me is displayed.",
      "profile-edit": "Edit Profile",
      "can-not-edit": "Edit is not possible.",
      "edit-avatar-complete": "Your avatar has been modified.",
      "change-password": "Change Password",
      "current-password": "Current Password",
      "new-password": "New Password",
      "new-password-check": "New Password Confirmation",
      "org-type-password-msg": "Only local DB can be modified.",
      "new-password-not-match":
        "The new password and password verification do not match.",
      "changed-password": "Your password has been changed.",
      back: "Back",
      "update-profile": "Update Profile",
    },
    "personal-address": {
      "header-title": "Personal Address",
      "add-address": "Add Address",
      "select-all": "Select All",
      delete: "Delete",
      name: "Name",
      grade: "Grade",
      company: "Company",
      email: "Email",
      edit: "Edit",
      select: "Select",
      "name-insert": "Insert Name",
      "grade-insert": "Insert Grade",
      "company-insert": "Insert Company",
      "email-insert": "Insert Email",
      add: "Add",
      update: "Update",
      "address-book-add": "Add Address",
      "address-book-edit": "Edit Address",
    },

    // Admin/sectrions
    "site-manage": {
      "header-title": "사이트 관리",
      "site-name": "사이트 이름",
      "site-name-for-api": "사이트 이름 (for Webex API)",
      "api-url": "Webex API Url",
      "license-count": "라이선스 수량",
      "site-edit": "사이트 상세 정보/수정",
      "open-conf-info": "열린 회의실 관리",
      "open-conf-account": "열린 회의실 계정",
      "open-conf-account-id": "열린 회의실 계정 ID",
      "open-conf-account-pw": "열린 회의실 계정 PW",
      "meeting-type": "meeting-type",
      "org-id": "OrgID",
      licenses: "라이선스 키값",
      "add-site": "사이트 추가",
      "add-site-complete-msg": "사이트를 추가 하였습니다.",
      "add-site-error-msg": "사이트를 추가가 실패 하였습니다.",
    },

    // Admin / Statistics
    statistics: {
      "meeting-name": "회의명",
      "meeting-date": "회의날짜",
      "meeting-time": "회의 예약 시간",
      "meeting-type": "회의 구분",
      creator: "개설자",
      codec: "회상장비참여자",
      mobile: "Mobile 참여자",
      pc: "PC 참여자",
      attendees: "총 초대자",
      "actual-attendees": "총 참여자",
      "join-info": "참여정보",
      company: "회사",
      building: "건물",
      "room-name": "회의실 이름",
      "meeting-room-usage-count": "회의실 이용 수",
      "meeting-room-usage-time": "회의실 이용 시간(분)",

      "meeting-info": "Meeting Info",
      "meeting-statistics": "Meeting Statistics",
      "room-meeting-count": "Room Meetings",
      "video-meeting-count": "Video Meetings",
      "total-attendees-count": "Total Attendees",
      "total-actual-attendees-count": "Actual Attendees",
      "pc-attendees-count": "PC Attendees",
      "mobile-attendees-count": "Mobile Attendees",
      "codec-attendees-count": "Codec Attendees",
      "reduce-cost-status": "Labor Cost Savings",
      "cost-saving-unit": "Won",
      "video-room-codec-statistics": "Video Room Codec Statistics",
      "pc-participant-statistics": "PC Participant Statistics",
      "mobile-participant-statistics": "Mobile Participant Statistics",
      "personal-codec-participant-statistics":
        "Personal Codec Participant Statistics",
      "meeting-count": "Meeting Count",
      "meeting-time-minute": "Meeting Time (Minute)",
      "video-meeting-statistics": "Video Meeting Statistics",
      "video-participants-status": "Video Participants Statistics",
      "user-meeting-info": "User Meeting Statistics",
      "user-meeting-usage": "Meeting Usage by User",
      "room-meeting-usage": "Meeting Usage by Meeting Room",
      "unauthorized-meeting": "Unauthorized Meeting Statistics",
      "preferred-meeting-room": "Preferred Meeting Room",
      "status-by-meeting-room": "Status by Meeting Room",
      "room-meeting": "Room Meeting",
      "video-meeting": "Video Meeting",
      "room-video-meeting": "Room + Video",
      "status-by-time": "Status by Time",
      "status-by-day-of-the-week": "Status by day of the Week",
      "daily-status": "Daily Status",
      "monthly-status": "Monthly Status",
      position: "Position",
      department: "Department",
      floor: "Floor",
      case: "Case",
      days: "Days",
      oclock: "o'clock",
      "device-name": "Device Name",
      "device-ip": "Device IP",
      manufacturer: "Manufacturer",
      "meeting-usage-count": "Number of device uses",
      "meeting-usage-time": "Device usage time (Minute)",
      capacity: "Capacity",
      "creat-meeting-count": "Number of Meetings Created",
      "meeting-participation-count": "Number of Meeting Participated",
      "meeting-participation-time": "time of Meeting Participated (Minute)",
      "all-meeting-status": "Finished Meeting Statistics",
      "room-meeting-statistics": "Room Meeting Infra Statistics",
      "all-status": {
        "meeting-name": "Meeting Name",
        "start-time": "Start Time",
        "end-time": "End Time",
        creator: "Creator",
        "creator-detail": "Creator(Name/Department)",
        building: "Building",
        "meeting-room": "Meeting Room",
        "meeting-type": "Meeting Type",
        department: "Department",
        status: "Status",
        codec: "Codec Attendees",
        mobile: "Mobile Attendees",
        pc: "PC Attendees",
        "actual-attendees": "Actual Attendees",
        attendees: "Attendees",
        "attendees-rate": "Attendees Rate",
        history: "History",
        "detail-info": "Detail Info",
        Delete: "Delete",
        video: "Video",
        room: "Room",
        lecture: "Lecture",
        proceeding: "Proceeding",
        finish: "Finish",
        reserve: "Reserved",
      },
      history: {
        "meeting-name": "Meeting Name",
        id: "Meeting ID",
        "client-agent": "Client Agent",
        "external-participant": "External Participant",
        ip: "IP Address",
        "join-time": "Join Time",
        "leave-time": "Leave Time",
        "meeting-key": "Meeting Key",
        name: "Name",
        participation: "Participation",
        "participant-type": "Participant Type",
        duration: "Duration(m)",
        "voip-duration": "voip Duration(m)",
        attendance: "Attendance",
        nonattendance: "Nonattendance",
        "attendees-msg":
          "Meeting Invitees: {attendees} , Meeting Participants : {actualAttendees}",
        attendees: "Attendees",
        codec: "Codec",
        position: "Position",
        department: "Department",
        email: "Email",
      },
      search: "Search",
      user: "User",
      email: "Email",
      export: "Export",
      "session-key": "Session Key",
    },

    // components/schedules
    schedules: {
      building: "Building",
      floor: "Floor",
      room: "Meeting Rooms",
      "meeting-reserve": "Reserve Meeting",
      total: "Total",
      msg: {
        overtime: "You can schedule meetings after the current time.",
        reserved:
          "Now is the time for the meeting room to be booked. Please use another time.",
        end: "It is a closed meeting.",
        "not-modify": "The meeting started and can not be edited.",
      },
    },
    "daily-meeting": {
      "room-name": "Rooms",
      "room-type": "Type",
      "room-capacity": "Capacity",
    },
    "weekly-meeting": {},
    "monthly-meeting": {},
    "record-mgr": {
      "meeting-date": "Date",
      "meeting-time": "Time",
      "gird-title": "Recording List",
      "meeting-name": "Meeting Name",
      "meeting-sta-time": "Meeting Start Time",
      "meeting-end-time": "Meeting End Time",
      creator: "Creator",
      "record-name": "Recording Name",
      "file-size": "Recording File Size",
      "recording-time": "Recording Time",
      streaming: "Streaming",
      download: "Download",
      delete: "Delete",
      "delete-title": "Delete record",
      "delete-record-content":
        "Are you sure you want to delete the selected record?",
      "deleted-record": "The record has been deleted.",
    },

    dashboard: {
      msg: {
        "no-progress-meetings": "There are no ongoing meetings.",
        "next-meeting-info":
          "The next meeting starts at {startDtime}. | There are no scheduled meetings today.",
      },
      "meeting-room": "Meeting Room",
      "video-device": "Video Meeting Room",
      "connected-video-device": "Connected Device",
      admin: "Admin",
      user: "User",
      meeting: "Meeting",
      "monthly-meeting": "Monthly Meetings",
      "room-meeting": "Room Meeting",
      "video-meeting": "Video Meeting",
      "preferred-meeting-room": "Preferred Meeting Room",
      "reserved-meeting": "Scheduled Meeting",
      "proceeding-meeting": "Proceeding Meeting",
      "end-meeting": "Finished Meeting",
      "all-meeting": "All Meetings",
      "video-meeting-room": "Video Room",
      "general-meeting-room": "Room",
      "all-license": "All licenses",
      "assigned-license": "Assigned licenses",
      "daily-reserve-meeting": "Today Meetings",
      "weekly-reserve-meeting": "Weekly Meetings",
      "monthly-reserve-meeting": "Monthly Meetings",
      "reduce-cost-status": "Labor Cost Savings",
      "video-participants-status": "Video Participants Status",
      "total-inviter": "Total inviter",
      "actual-participants": "Actual participants",
      "overall-participation-rate": "Total participation rate",
      "monthly-participation-rate": "Monthly participation rate",
      "weekly-participation-rate": "Weekly participation rate",
      "today-participation-rate": "Today participation rate",
      "total-cost-savings": "Total cost savings",
      "monthly-cost-savings": "Monthly cost savings",
      "weekly-cost-savings": "Weekly cost savings",
      "today-cost-savings": "Today cost savings",
      "meeting-list": "Meetings List",
      "system-mgr": "System Management",
      "today-meeting-usage-status": "Meeting status (Today)",
      "participant-type": "Participant types (This month)",
    },
    "meetingroom-mgr": {
      "building-search": "Search Building",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      close: "Close",
      "building-delete-title": "Delete Building",
      "building-delete-content":
        "Are you sure you want to delete the selected building?",
      "building-delete-complete": "The building has been deleted.",
      building: {
        "building-add": "Building Add",
        "building-edit": "Building Edit",
        name: "*Building Name",
        "bottom-floor": "*Bottom Floor",
        "top-floor": "*Top Floor",
        "floor-invaild":
          "The value of high-rise is lower than that of low-rise.",
        "add-complete": "The building has been added.",
        "edit-complete": "The building has been edited.",
      },
      "meeting-room": {
        "building-select": "Please select a building.",
        add: "Add Meeting Room",
        floor: "Room Floor",
        name: "Room Name",
        type: "Room Type",
        "type-room": "Room",
        "type-video": "Video",
        status: "Room status",
        "status-waiting": "Waiting",
        "status-in-meeting": "In Meeting",
        capacity: "Capacity",
        "edit-delete": "Edit/Delete",
        "delete-title": "Delete Meeting Room",
        "delete-content": "Are you sure you want to delete the selected room?",
        "delete-complete": "The meeting room has been deleted.",
      },
      "add-edit-room": {
        add: "Add Meeting Room",
        edit: "Edit Meeting Room",
        name: "*Meeting Room Name",
        type: "*Meeting Room Type",
        floor: "*Floor",
        capacity: "*Capacity",
        "add-complete": "The meeting room has been added.",
        "edit-complete": "The meeting room has been edited.",
      },
      "field-missing": "* Please enter a * field value.",
      "people-unit": "Person",
      "floor-unit": "Floor",
    },
    "device-mgr": {
      "cisco-device": "Cisco Video Room",
      "polycom-device": "Polycom Video Room",
      "other-device": "Other Video Room",
      "video-infra": "Video Meeting Infra",
      "device-list": "Video Device List",
      building: "Building",
      type: "Type",
      room: "Room",
      "personal-device": "Personal Device",
      "room-name": "Room Name",
      "device-url": "Device URL",
      "device-ip": "Device IP",
      "device-id": "Deivce ID",
      model: "Model",
      "device-link": "Device Link",
      contacts: "Phonebook",
      "device-status": "Status",
      "edit-delete": "Edit/Delete",
      "add-edit-device": {
        "add-device": "Add Video Device",
        "edit-device": "Edit Video Device",
        building: "Building",
        type: "Type",
        room: "Meeting Room",
        "device-name": "Device Name",
        user: "User",
        manufacturer: "Manufacturer",
        "join-type": "How to join a meeting",
        "device-ip": "Device IP",
        "device-url": "Device URL",
        "display-name": "Display Name",
        "device-id": "Device ID",
        "device-pw": "Device Password",
        model: "Model",
        save: "SAVE",
        cancel: "CANCEL",
        "edit-comp-msg": "The device has been edited.",
        "add-comp-msg": "The device has been registerd.",
      },
      "delete-device-title": "Delete Video Device",
      "delete-device-content":
        "Are you sure you want to delete the selected device?",
      "delete-device-complete": "The device has been deleted.",
      "update-phone-book-complete": "Phone Book is updated.",
      "update-phone-book-fail": "Updating Phone Book is failed.",
      "import-phone-book-title": "Phone Book Import",
      "import-phone-book-content":
        "Erase the phone book of the video device and put it as the registered information in Webex Manager. Would you like to proceed?",
      "save-phone-book-complete": "Phone book storage is complete.",
      "save-phone-book-fail": "Saving phone book failed.",
      "field-missing": "Please fill in all the required fields.",
      "phone-book": {
        text: "Phone Book Data",
        data: "Phone Book Data",
        version: "Version",
        "version-name": "Version Name",
      },
    },
    log: {
      "log-list": "Log List",
      created: "Log Time",
      action: "Action",
      "action-email": "Agent",
      ip: "IP",
      "log-msg": "Info",
    },
    "user-mgr": {
      local: {
        "user-list": "User List",
        "local-db-user-msg": "User registered in local DB.",
        "email-name-search": "Email, Name Search",
        email: "Email",
        name: "Name",
        position: "Position",
        department: "Department",
        "create-time": "Registration date",
        license: "License",
        role: "Role",
        status: "Status",
        assign: "License Assign",
        unassign: "Un Assign",
        delete: "License Recall",
        "delete-user-title": "License Recall",
        "delete-token": "Token Delete",
        "delete-user-content":
          "Are you sure you want to delete the selected user?",
        "delete-token-complete": "Token Deleted is complete.",
        cancel: "Cancel",
        all: "All",
        "user-status": "Employment/New/Retirement/Long-term Non User",
        "work-user": "Incumbent",
        "new-user": "New hires",
        "del-user": "Resigner",
        "non-user": "Long-term Non User",
        "assign-user": "Assignee",
        "non-assign-user": "Unassigned",
        "role-admin": "Admin",
        "role-user": "User",
        "role-change-msg": " permissions have been changed.",
        "user-active-msg": " status has been Active.",
        "retrieve-licenses-comp": "License retrieve is complete.",
        "assign-licenses-comp": "License assign is complete.",
        "retrieve-licenses-fail": "License retrieve is fail.",
        "assign-licenses-fail": "License assign is fail.",
        "delete-user-msg": "The user has been deleted.",
        "add-user-manual": "Add Manual User",
        "assign-licenses": "Assign Licenses",
        "retrieve-licenses": "Retrieve Licenses",
        "no-assign-avail-user": "Please select an assignable user.",
        "add-user-msg": "User added complete.",
        "license-manage": "Manage License",
        "user-search": "User Search",
        "assign-usr-list": "License Assign User List",
        "license-assign-complete": "License assignment is complete.",
        "license-assign-fail": "License assignment failed.",
        "sso-login-msg":
          "Assigning and deleting licenses requires a Teams ID login of the administrator account.",
        "license-sso-login-admin-msg":
          "Only an administrator account can register a license. Please check your Webex Teams Login and account permissions.",
      },
    },
    "webex-license": {
      "user-list": "Webex User List",
      "local-db-user-msg": "User registered in local DB.",
      "email-name-search": "Email, Name Search",
      email: "Email",
      name: "Name",
      "create-time": "Registration date",
      role: "Role",
      status: "Status",
      delete: "Delete",
      "delete-user-title": "User Delete",
      "delete-user-content":
        "Are you sure you want to delete the selected user?",
      cancel: "Cancel",
      "role-admin": "Admin",
      "role-user": "User",
      "role-change-msg": " permissions have been changed.",
      "user-active-msg": " status has been Active.",
      "delete-user-msg": "The user has been deleted.",
    },
    "system-mgr": {
      "save-comp-msg": "Save was successful.",
      "save-fail-msg": "Failed to save.",
      "check-comp-msg": "Confirmation was successful.",
      "check-fail-msg": "Check failed.",
      license: {
        "device-license": "Device License",
        "ecs-admin-login-msg": "Enter ECS Admin PW to modify license",
        password: "Password",
        conf: "Confirm",
        "license-msg": "Change number of licenses",
        cisco: "Cisco",
        polycom: "Polycom",
        other: "Ohter",
      },
      "organization-composition": {
        "organization-composition": "Organization Composition",
        "local-db": "Local DB",
        ldap: "LDAP",
        "personnel-db": "Personnel DB Interworking",
        "local-db-desc": "Local DB does not need any additional settings.",
        "setting-changed-msg": "Organization chart settings have changed.",
        "add-ldap": "Add LDAP ",
        "edit-ldap": "Edit LDAP",
        title: "Title",
        comment: "comment",
        ip: "IP address",
        port: "Port",
        "user-name": "Username",
        pw: "Password",
        "base-node": "Base Node",
        filter: "Filter",
        status: "Status",
        "last-sync-time": "Last sync time",
        add: "Add",
        sync: "Sync",
        "edit-delete": "Edit/Delete",
        save: "Save",
        cancel: "Cancel",
        "delete-ldap-title": "Delete Ldap",
        "delete-ldap-content":
          "Are you sure you want to delete the selected ldap?",
        "delete-ldap-complete": "The device has been deleted.",
        "edit-comp-msg": "The ldap has been edited.",
        "add-comp-msg": "The ldap has been registerd.",
        "ldap-sync-comp-msg": "Ldap synchronization is complete.",
        "change-site-setting": "Change site setting",
        "change-site-setting-info":
          "Changing the site settings will refresh the page.",
        "invaild-db-info-value": "The input value is invalid.",
      },
      "meeting-composition": {
        "meeting-composition": "Meeting Composition",
        "meeting-record-init": "Recording initial setting at reservation",
        "lecture-mute-init": "Mute initial setting at lecture",
        "meeting-join-before-time":
          "Available minutes before the start of the meeting",
        "meeting-reserve-interval": "Calendar time interval (minutes) / slot",
        "work-hours": "Work Hours",
        "setting-changed-msg": "Meeting settings have changed.",
        "cost-saving-unit": "Won",
        "cost-saving-per-hour": "Savings per meeting hour",
        "use-room-meeting": "Use Room Meeting",
        "add-meeting-msg": "Meeting added complete.",
        "edit-meeting-msg": "Meeting edited complete.",
        "delete-meeting-msg": "Meeting deleted complete.",
      },
      "webex-composition": {
        "webex-composition": "Webex Composition",
        "chat-bot-use": "Use Webex Chat Bot",
        "setting-changed-msg": "Webex settings have changed.",
      },
      "smtp-setting": {
        "smtp-setting": "SMTP Setting",
        "from-email": "From Email",
        host: "Host",
        port: "Port",
        "user-name": "User Name",
        password: "Password",
        "password-confirm": "Confirm Password",
        "setting-changed-msg": "SMTP settings have changed.",
        "invaild-value": "The input value is invalid.",
      },
      "manager-setting": {
        "manager-setting": "Site Setting",
        "main-page": "Select main page",
        "dashboard-detail": "View dashboard details",
        "user-view-record-page": "View user recording files",
        "notice-msg": "Notice Messasge",
        "help-desk-number": "Help Desk Number",
        "cisco-webex-hub": "Cisco Webex Hub Address",
        "notice-duration": "Notice Duration",
        "setting-changed-msg": "Site settings have changed.",
      },
      save: "SAVE",
      revert: "REVERT",
    },
    "manual-download": {
      msg: {
        "upload-complete": "The manual has been uploaded.",
        "delete-complete": "The manual has been deleted.",
      },
      confirm: "Confirm",
      "file-upload": "File Upload",
      "manual-downlaod": "Manual Download",
    },
    "meeting-control": {
      "meeting-control": "Meeting Control",
      "on-call": "On Call",
      "on-ohter-call": "In Another Call",
      waiting: "Waiting",
      invitation: "Invitation",
      refresh: "Refresh",
      close: "Close",
      "device-list": {
        name: "Device Name",
        model: "Device Model",
        "webex-conn-status": "Webex Connection Status",
        status: "Status",
        ip: "IP",
        link: "Device Link",
        connection: "Connection",
        "hang-up": "Hang up",
        "call-status": "Call Status",
      },
      "device-status": {
        "call-status": "Call Status",
        "call-details": "Call Details",
        "out-audio": "Outgoing Audio",
        "in-audio": "Incoming Audio",
        "out-video": "Outgoing Video",
        "in-video": "Incoming Video",
        "presention-in-video": "Presention Incoming Video",
        "presention-out-video": "Presention Outgoing Video",
        protocol: "Protocol",
        encryption: "Encryption",
        "tran-call-rate": "Transmit Call Rate",
        "receive-call-rate": "Receive Call Rate",
        "channel-rate": "Channel Rate",
        "total-packet-loss": "Total Packet Loss",
        "cur-packet-loss": "Current Packet Loss",
        jitter: "Jitter",
        Resolution: "Resolution",
        "frame-rate": "Frame Rate",
      },
      "refresh-all": "All Refresh",
      "refresh-all-content":
        "If there are a lot of devices in the list, it may take a long time. Do you want to refresh all?",
      confirm: "Confirm",
      "dial-err-msg": "Meeting connection failed.",
      "disconnect-err-msg": "Failed to disconnect the conference.",
      "invite-select": "Additional Invite",
      "room-invite": "Room Invite",
      "personal-device-invite": "Personal Device Invite",
      "no-dial-list-msg":
        "There are no more meeting rooms. Please check the status after refreshing.",
    },
  },
};

export default message;



// WEBPACK FOOTER //
// ./src/i18n/en.js